import React from 'react';

const Version = _ => {
    return (
        <span>20260527.4</span>
    );
};

export default Version;